<template>
  <el-dialog
    title="新增会员价格"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      size="small"
    >


      <el-form-item
              prop="title"
              label="标题"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.title"></el-input>
      </el-form-item>

      <el-form-item
              prop="title_details"
              label="会员特权"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.title_details"></el-input>
      </el-form-item>

      <el-form-item
        prop="card_type"
        label="类型"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.card_type"
                placeholder="请选择"
                width="50"
        >

          <el-option
                  v-for="item in typeOptions3"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>


        </el-select>
      </el-form-item>


      <el-form-item
              prop="price"
              label="价格(元)"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.price"></el-input>
      </el-form-item>



      <el-form-item
              prop="mobkey_type"
              label="方式"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.mobkey_type"
                placeholder="请选择"
                width="50"
        >

          <el-option
                  v-for="item in typeOptions5"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>


        </el-select>
      </el-form-item>



      <el-form-item
              prop="state"
              label="是否上架"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.state"
                placeholder="请选择"
                width="50"
        >

          <el-option
                  v-for="item in typeOptions4"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>


        </el-select>
      </el-form-item>


      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
    import * as memberService from "@/api/sys/member";
    import util from '@/libs/util.js'
export default {
  name: "agentEditForm",
  props: {
      agent: Object,
    value: Boolean
  },
  data() {
    return {
        formEdit: true,
        formEdit2: true,
      loading: false,
      dialogVisible: false,
        pickerOptions: {}, // 日期设置对象
      form: {
        card_type: "",
       price: "",
        title: "",
       title_details: "",
        unit: "",
        state: "",
        grade: "",
        cashback_type: "",
        variety_discount: 5,
        wine_discount: 5,
       notice : ""

      },
      ptspOptions: [{ value: "0",
        label: "现金"},{ value: "1",
        label: "余额"}],
      typeOptions5: [{
        value: "1",
        label: "在线支付"
      },
        {
          value: "2",
          label: "后台审核"
        }],
      typeOptions4: [{
        value: "0",
        label: "上架"
      },
        {
          value: "1",
          label: "下架"
        }],
        typeOptions3: [{
            value: "全国代理",
            label: "全国代理"
        },
            {
                value: "运营商",
                label: "运营商"
            },
            {
                value: "运营中心",
                label: "运营中心"
            },
          {
            value: "全国代理",
            label: "全国代理"
          }]
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {

    dialogOpen() {
      this.$refs.form.resetFields();

      if (this.agent.id) {
       // userService.getUser(this.user.id).then(data => {
          let form = {};
        form.card_type = this.agent.card_type;
        form.price = this.agent.price;
        form.title = this.agent.title;
        form.title_details = this.agent.title_details;


        form.state = this.agent.state;

        form.mobkey_type = this.agent.mobkey_type;

          this.form = form;
       // });
          this.formEdit = true;
          this.formEdit2=false;
      } else {

          this.formEdit = true;
          this.formEdit2=true;
        //this.form = {};
      }
    },

    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {

                this.loading = true;
              memberService.saveMemberCard({ ...this.form,agentid:util.cookies.get('agentid'), id:this.agent.id ,xt_id:util.cookies.get('xt_id')})
                    .then(data => {
                        this.loading = false;
                        this.dialogVisible = false;
                        this.$emit("submit");
                    });

        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

